import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { RootState } from '~/redux/store'
import { LoginScenario } from '~/types/login'

import { LoginFields, LOGIN_VIEW, LoginState, SimpleUserProfile } from '~/auth/types/login.types'

import { logout } from '~/auth/slices/auth.slice'

const INIT_LOGIN_FIELDS = {
  email: '',
  password: '',
}
const INIT_LOGIN_FIELDS_ERRORS = {
  email: '',
  password: '',
}
const initialState: LoginState = {
  fields: INIT_LOGIN_FIELDS,
  errors: INIT_LOGIN_FIELDS_ERRORS,
  backendError: '',
  loginScenario: LoginScenario.DEFAULT,
  simpleUserProfile: {},
  view: LOGIN_VIEW.DEFAULT,
}

const slice = createSlice({
  name: 'login',
  initialState,
  reducers: {
    setFields: (state, action: PayloadAction<Partial<LoginFields>>) => ({
      ...state,
      fields: { ...state.fields, ...action.payload },
    }),

    setBackendError: (state, action: PayloadAction<string>) => ({
      ...state,
      backendError: action.payload,
    }),

    setSimpleUserProfile: (state, action: PayloadAction<SimpleUserProfile>) => ({
      ...state,
      simpleUserProfile: action.payload,
    }),

    setView: (state, action: PayloadAction<LOGIN_VIEW>) => ({
      ...state,
      view: action.payload,
    }),
  },
  extraReducers: (builder) => {
    builder.addCase(logout, () => initialState)
  },
})

export const selectFields = (state: RootState): LoginFields => state.login.fields

export const selectBackendError = (state: RootState): string => state.login.backendError

export const selectSimpleUserProfile = (state: RootState): SimpleUserProfile => state.login.simpleUserProfile

export const selectView = (state: RootState): string => state.login.view

export const {
  setFields: setFieldsActionCreator,
  setBackendError: setBackendErrorActionCreator,
  setSimpleUserProfile: setSimpleUserProfileActionCreator,
  setView: setViewActionCreator,
} = slice.actions

export default slice.reducer
